import { supabase } from '../lib/supabase'

import {truncateDexie as truncateDexieFacility} from "../models/facility";
import {truncateDexie as truncateDexieUsers } from "../models/users";
import {truncateDexie as truncateDexieSectionB} from "../models/sectionb";
import {truncateDexie as truncateDexieSectionA} from "../models/sectiona";
import {truncateDexie as truncateDexieElephants} from '../models/elephants';
import {truncateDexie as truncateDexieChanges} from '../models/changes';
import {truncateDexie as truncateDexieAssessments} from '../models/assessments';
import {truncateDexie as truncateDexieFinalEvaluations} from '../models/finalevaluation';
import {truncateDexie as truncateDexieSectionC} from "../models/sectionc";
import {truncateDexie as truncateDexieSectionCIoA} from "../models/sectioncioa";

async function jsonToStorage(fileName, jsonString) {
    const { data, error } = await supabase.storage
      .from(process.env.REACT_APP_SUPABASE_BUCKET_NAME)
      .upload(fileName, jsonString);
  
    if (error) {
      throw error;
    } else {
      return data;
    }
  }


const execute = async(input) => {
    const {data, error} = await input;
    if (error) throw error;
    return data;
}

const executeReturnRow = async(input) => {
    const {data, error} = await input;
    if (error) throw error;
    if (data.length === 0) throw new Error("Could not locate row of data");
    return data[0];
}

const createSignedUrl = async ({bucketName,bucketKey,expiresIn = 300, options = {download: true}}) => {
  console.log(bucketName,bucketKey,expiresIn,options);
  try {
    const results = await execute(supabase.storage.from(bucketName).createSignedUrl(bucketKey,expiresIn,options))	
    return results.signedUrl;
  } catch (error) {
    console.error(error);
    return undefined;
  }
}

const truncateLocalData = async () => {
  try {
    await truncateDexieSectionCIoA();
    await truncateDexieSectionC();
    await truncateDexieSectionB();
    await truncateDexieSectionA();
    await truncateDexieAssessments();
    await truncateDexieFinalEvaluations();
    await truncateDexieUsers();
    await truncateDexieElephants();
    await truncateDexieChanges();
    await truncateDexieFacility();

  } catch (error) {
    throw error;
  }
}

export {jsonToStorage,execute,executeReturnRow,createSignedUrl, truncateLocalData}